<template>
	<div>
		<div class="checkbox-radios">
			<base-radio v-for="(el_opt, el_index) in rb_options" :key="el_index" :name="el_opt.name" v-model="rb_model" inline>{{el_opt.label}}</base-radio>
		</div>
		<div v-if="hide_staffsearch === false">
			<ReInputSearchDrop 
				v-if="(rb_model=='2')"
				:findId="findId"
				:name="name"
				:placeholder="placeholder"
				v-model="search_model"
				:objApiMethod="objApiMethod"
				:strApiMethodKey="strApiMethodKey"
				:strType="'staff'"
				@change="onClientSelect"
			/>
		</div>
		<div v-if="hide_staffsearch === false">
			<ReInputSearchDrop 
				v-if="(rb_model=='3')"
				:findId="findId"
				:name="name"
				:placeholder="placeholder_otdel"
				v-model="search_model_otdel"
				:objApiMethod="objApiMethod_otdel"
				:strApiMethodKey="strApiMethodKey_otdel"
				:strType="'otdel'"
				@change="onClientSelect_otdel"
			/>
		</div>
	</div>
</template>

<script>
	import { BaseRadio } from 'src/components/index';
	import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
	import {eventEmitter} from "src/plugins/globalComponents";
	
	export default {
		name: 'ReSearchStaffClients',
		components: {
			BaseRadio,
			ReInputSearchDrop
		},
		props: {
			hide_staffsearch:{
				type: Boolean,
				default: false
			},
			placeholder: String,
			placeholder_otdel: String,
			name: String,
			objApiMethod: {
				type: Object,
				default() {	return {}; }
			},
			strApiMethodKey:{
				type: String,
				required: true
			},
			objApiMethod_otdel: {
				type: Object,
				default() {	return {}; }
			},
			strApiMethodKey_otdel:{
				type: String,
				required: true
			},
			MinTxtLen: {
				type: Number,
				default:2,
			},
			value: {
				type: Object,
				default() {	return {'agent_id':'','otdel_id':'','isFired':''}; }
			},
			findId: { //это свойсво удалять не надо, оно хорошее и моет быть использовано в опуиях для формпринтера или фильтрпринтера
				type: String,
				default: '',
			},
			rb_options:{
				type: Array,
				default: function(){ 
					let masRet = [
						{'name' : '0', 'label' : 'Все клиенты'}, 
						{'name' : '1', 'label' : 'Мои клиенты'}
					];
					if(this.hide_staffsearch === false){
						masRet.push({'name' : '2', 'label' : 'Клиенты сотрудника'});
						masRet.push({'name' : '3', 'label' : 'Клиенты отдела'});
					}
					return masRet;
				}
			},
			showFired:{
				type: Boolean,
				default: true
			},
		},
		data () {
			return {
				ver: 1,
				rb_model: '0',
				search_model: {'inputText' : '', 'selectedVal' : ''},
				search_model_otdel: {'inputText' : '', 'selectedVal' : ''},
				cat_timer: null,
				profile_code: this.$GVO.my_profile.code,
			}
		},
		watch: {
			rb_model:function(val){
				//console.log(val,this.value);
				if(val=='0'){
					this.search_model = {'inputText' : '', 'selectedVal' : ''};
					this.search_model_otdel = {'inputText' : '', 'selectedVal' : ''};
					this.$emit('input', {'agent_id':'','otdel_id':'','isFired':''});
					this.$emit('change', {'agent_id':'','otdel_id':'','isFired':''});
					// console.log(this.value, 'this.value');
				}
				if(val=='1'){
					this.search_model_otdel = {'inputText' : '', 'selectedVal' : ''};
					this.search_model = {'inputText' : '', 'selectedVal' : this.$GVO.my_profile.code};
					this.$emit('input', {'agent_id':this.$GVO.my_profile.code,'otdel_id':'','isFired':''});
					this.$emit('change', {'agent_id':this.$GVO.my_profile.code,'otdel_id':'','isFired':''});
				}
				if(val=='2'){
					let agent_id='';
					if(typeof this.value.agent_id != 'undefined' && this.value.agent_id != '') {
						agent_id=this.value.agent_id;
						this.GetAgentName();
					}
					this.search_model_otdel = {'inputText' : '', 'selectedVal' : ''};
					this.search_model = {'inputText' : '', 'selectedVal' : agent_id};
					this.$emit('input', {'agent_id':agent_id,'otdel_id':'','isFired':''});
					this.$emit('change', {'agent_id':agent_id,'otdel_id':'','isFired':''});
				}
				if(val=='3'){
					let otdel_id='';
					if(typeof this.value.otdel_id != 'undefined' && this.value.otdel_id != '') {
						otdel_id=this.value.otdel_id;
						this.GetOtdelName();
					}
					this.search_model_otdel = {'inputText' : otdel_id, 'selectedVal' : otdel_id};
					this.search_model = {'inputText' : '', 'selectedVal' : ''};
					this.$emit('input', {'agent_id':'','otdel_id':otdel_id,'isFired':''});
					this.$emit('change', {'agent_id':'','otdel_id':otdel_id,'isFired':''});
					// console.log(this.value, 'this.value');
				}
				if(val=='4'){
					this.search_model_otdel = {'inputText' : '', 'selectedVal' : ''};
					this.search_model = {'inputText' : '', 'selectedVal' : ''};
					this.$emit('input', {'agent_id':'','otdel_id':'','isFired':'1'});
					this.$emit('change', {'agent_id':'','otdel_id':'','isFired':'1'});
				}
			},
			
			value:{
				handler:function(val,prevVal){
					// console.log('val', val);
					// console.log('prevVal', prevVal);
					if((val.agent_id=='' && val.isFired=='' && val.otdel_id=='') && (prevVal.agent_id!=='' || prevVal.isFired!=='' || prevVal.otdel_id!=='')){
						
						// this.rb_model = '0'; //маша: закоменнтила, так как при выборе val 3 (отдел) все равно проставляется rb_model 0
						this.search_model = {'inputText' : '', 'selectedVal' : ''};
						this.search_model_otdel= {'inputText' : '', 'selectedVal' : ''};
						
					}
				},
				deep:true,
			},
			
			otdel_id:function(val){
				if(val!=''){
					this.rb_model = '3';
				}
			},
			isFired:function(val){
				if(val=='1'){
					this.rb_model = '4';
				}
			},
			profile_code:function(val){
				if(this.agent_id == val){
					this.rb_model = '1';
				}
			},
			agent_id:function(val){
				if(val == this.profile_code){
					this.rb_model = '1';
				} else if(val!=''){
					this.rb_model = '2';
				}
			}
		},
		computed:{
			//staff_type: function(){return this.value.staff_type;}
			isFired: function(){return this.value.isFired;},
			agent_id: function(){return this.value.agent_id;},
			otdel_id: function(){return this.value.otdel_id;},
		},
		methods: {
			onClientSelect(staff){
				this.value.agent_id = staff.selectedVal;
				this.value.otdel_id = '';
				this.$emit('input', this.$GVO.unlinkObject(this.value));
				this.$emit('change', this.$GVO.unlinkObject(this.value));
			},
			onClientSelect_otdel(otdel){
				this.value.otdel_id = otdel.selectedVal;
				this.value.agent_id = '';
				this.$emit('input', this.$GVO.unlinkObject(this.value));
				this.$emit('change', this.$GVO.unlinkObject(this.value));
			},
			GetAgentName(){
				this.cat_timer = setTimeout(() => {
					//console.log('GetAgentName',this.cat_timer);
					if(typeof this.value != 'undefined' && this.value.agent_id != ''){
						if(typeof this.$GVO.GetCat('CAT_STAFF',this.value.agent_id).name != 'undefined'){
							if(this.value.agent_id != '' && typeof this.value.agent_id != 'undefined'){
								this.search_model = this.$GVO.unlinkObject({'inputText' : this.$GVO.GetCat('CAT_STAFF',this.value.agent_id).name, 'selectedVal' : this.value.agent_id});
							}
							clearTimeout(this.cat_timer);
							this.cat_timer = null;
						}else{
							this.search_model = this.$GVO.unlinkObject({'inputText' : '', 'selectedVal' : this.value.agent_id});
						}
					}else{
						clearTimeout(this.cat_timer);
						this.cat_timer = null;
					}
				}, 250);
				return this.$GVO.GetCat('CAT_STAFF',this.value.agent_id).name;
			},
			GetOtdelName(){
				this.search_model_otdel = {'inputText' : this.value.otdel_id, 'selectedVal' : this.value.otdel_id};
				if(typeof this.value != 'undefined' && this.value.otdel_id != ''){
					this.$GVO.ApiCall('structures.GET',{flt:{'id':this.value.otdel_id}})
						.then((objApi) => {
							if(objApi.success === true && objApi.data.length>0){
								//console.log(objApi);
								this.search_model_otdel = {'inputText' : objApi.data[0].name, 'selectedVal' : this.value.otdel_id};
							}
						}).catch(errorObjApi => console.error(errorObjApi));
				}
			},
			profile_load(data){
				this.profile_code = data.code;
			}
		},
		mounted(){
			
			if((this.value.agent_id == '' && this.value.otdel_id == '' && this.value.isFired == '') || typeof this.value == 'undefined'){
				this.rb_model = '0';
			}else if(this.value.agent_id == this.$GVO.my_profile.code){
				this.rb_model = '1';
			} else if(this.value.agent_id!='' && this.value.otdel_id == ''){
				this.rb_model = '2';
			} else if(this.value.agent_id == '' && this.value.otdel_id != ''){
				this.rb_model = '3';
			} else if(this.value.agent_id == '' && this.value.otdel_id == '' && this.value.isFired != ''  ){
				//if(this.rb_options.lengtheventEmitter.$on('profile_load', this.profile_load)>4)this.rb_model = '4';
				const objGet = this.$GVO.GetAllGet();
				if(typeof this.value.isFired != 'undefined' && this.value.isFired == '1' )this.rb_model = '4';
				else if(typeof objGet.isFired != 'undefined' && objGet.isFired == '1')this.rb_model = '4';
			}
			
			this.GetAgentName();
			this.GetOtdelName();
			
			eventEmitter.$on('profile_load', this.profile_load)
			
		},
		unmounted(){
			eventEmitter.$off('profile_load', this.profile_load)
		}
	}
</script>
<style scoped>

</style>
